<template>
    <section class="signature">
        <div class="signatureBox">
            <div class="canvasBox" ref="canvasHW">
                <p style="margin:0 0 10px;line-height:20px;color:#999;">
                    请在以下矩形区域内绘制，完成需点击确定并上传
                </p>
                <canvas
                    ref="canvasF"
                    @touchstart="touchStart"
                    @touchmove="touchMove"
                    @touchend="touchEnd"
                    @mousedown="mouseDown"
                    @mousemove="mouseMove"
                    @mouseup="mouseUp"
                ></canvas>
                <div class="btnBox">
                    <el-button size="small" @click="overwrite"
                        >清空</el-button
                    >
                    <el-image v-if="previewArr.length" style="height: 32px" :src="previewArr[0]" :preview-src-list="previewArr"></el-image>
                    <el-button
                        size="small"
                        :disabled="!isText"
                        type="primary"
                        @click="commit"
                        >确定并上传</el-button
                    >
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import COS from "cos-js-sdk-v5";
export default {
    name: 'signature',
    props: {
      value: {
        type: String,
        default: ""
      },
      change: Function,
      prop: String,
      skipType: undefined,
      skipValue: String,
    },
    data() {
        return {
            isText: false,

            stageInfo: '',
            client: {},
            points: [],
            canvasTxt: null,
            startX: 0,
            startY: 0,
            moveY: 0,
            moveX: 0,
            endY: 0,
            endX: 0,
            w: null,
            h: null,
            isDown: false,
            previewArr: [],
            ossValue: {},
            // isViewAutograph: this.$route.query.isViews > 0,
            // contractSuccess: this.$route.query.contractSuccess,
        }
    },
    watch: {
      'value'(val) {
        if(!val) {
          this.overwrite()
          this.previewArr = []
        } else {
          this.previewArr = [val]
          this.$emit('input', val)
        }
        if(this.change && typeof(this.change)=='function') this.change({value: val, column: this})
      }
    },
    mounted() {
        // 找到 <canvas> 元素
        let canvas = this.$refs.canvasF
        canvas.height = this.$refs.canvasHW.offsetHeight - 87
        canvas.width = this.$refs.canvasHW.offsetWidth - 2
        // 创建 context 对象
        this.canvasTxt = canvas.getContext('2d')
        this.stageInfo = canvas.getBoundingClientRect()

        var _this = this
        window.addEventListener('scroll', function(){
          _this.stageInfo = canvas.getBoundingClientRect()
        })
        this.getOssToken();
    },
    methods: {
        //mobile
        touchStart(ev) {
            this.stageInfo = this.$refs.canvasF.getBoundingClientRect()
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
                let obj = {
                    x: ev.targetTouches[0].clienX - this.stageInfo.left,
                    y: ev.targetTouches[0].clientY - this.stageInfo.top,
                }
                this.startX = obj.x
                this.startY = obj.y
                this.canvasTxt.beginPath()
                this.canvasTxt.moveTo(this.startX, this.startY)
                this.canvasTxt.lineTo(obj.x, obj.y)
                this.canvasTxt.stroke()
                this.canvasTxt.closePath()
                this.points.push(obj)
            }
        },
        touchMove(ev) {
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
                let obj = {
                    x: ev.targetTouches[0].clientX - this.stageInfo.left,
                    y: ev.targetTouches[0].clientY - this.stageInfo.top,
                }
                this.moveY = obj.y
                this.moveX = obj.x
                this.canvasTxt.beginPath()
                this.canvasTxt.moveTo(this.startX, this.startY)
                this.canvasTxt.lineTo(obj.x, obj.y)
                this.canvasTxt.stroke()
                this.canvasTxt.closePath()
                this.startY = obj.y
                this.startX = obj.x
                this.points.push(obj)
                this.isText = true
            }
        },
        touchEnd(ev) {
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
                let obj = {
                    x: ev.targetTouches[0].clientX - this.stageInfo.left,
                    y: ev.targetTouches[0].clientY - this.stageInfo.top,
                }
                this.canvasTxt.beginPath()
                this.canvasTxt.moveTo(this.startX, this.startY)
                this.canvasTxt.lineTo(obj.x, obj.y)
                this.canvasTxt.stroke()
                this.canvasTxt.closePath()
                this.points.push(obj)
                this.isText = true
            }
        },
        //pc
        mouseDown(ev) {
            ev = ev || event
            ev.preventDefault()
            // if (1) {
                // 鼠标相对于事件源元素（srcElement）的X,Y坐标
                let obj = {
                    x: ev.offsetX,
                    y: ev.offsetY,
                }
                this.startX = obj.x
                this.startY = obj.y
                // 起始一条路径，或重置当前路径
                this.canvasTxt.beginPath()
                // 把路径移动到画布中的指定点，不创建线条
                this.canvasTxt.moveTo(this.startX, this.startY)
                // 添加一个新点，然后在画布中创建从该点到最后指定点的线条
                this.canvasTxt.lineTo(obj.x, obj.y)
                // 绘制已定义的路径
                this.canvasTxt.stroke()
                // 创建从当前点回到起始点的路径
                this.canvasTxt.closePath()
                this.points.push(obj)
                this.isDown = true
            // }
        },
        mouseMove(ev) {
            ev = ev || event
            ev.preventDefault()
            if (this.isDown) {
                let obj = {
                    x: ev.offsetX,
                    y: ev.offsetY,
                }
                this.moveY = obj.y
                this.moveX = obj.x
                this.canvasTxt.beginPath()
                this.canvasTxt.moveTo(this.startX, this.startY)
                this.canvasTxt.lineTo(obj.x, obj.y)
                this.canvasTxt.stroke()
                this.canvasTxt.closePath()
                this.startY = obj.y
                this.startX = obj.x
                this.points.push(obj)
                this.isText = true
            }
        },
        mouseUp(ev) {
            ev = ev || event
            ev.preventDefault()
            // if (1) {
                let obj = {
                    x: ev.offsetX,
                    y: ev.offsetY,
                }
                this.canvasTxt.beginPath()
                this.canvasTxt.moveTo(this.startX, this.startY)
                this.canvasTxt.lineTo(obj.x, obj.y)
                this.canvasTxt.stroke()
                this.canvasTxt.closePath()
                this.points.push(obj)
                this.points.push({ x: -1, y: -1 })
                this.isDown = false
                this.isText = true
            // }
        },
        //重写
        overwrite() {
            this.canvasTxt.clearRect(
                0,
                0,
                this.$refs.canvasF.width,
                this.$refs.canvasF.height
            )
            this.points = []
            this.isText = false
            this.$emit('input', '')
        },
        //提交签名
        async commit() {
            // this.isText = false
            const { canvas } = this.canvasTxt

            const res = await this.oss_upload(
              canvas.toDataURL('image/png', 0.1)
            )
            this.$emit('input', res)
            // this.value = this.$refs.canvasF.toDataURL()
        },

        getUuid() {
            var temp_url = URL.createObjectURL(new Blob())
            var uuid = temp_url.toString()
            URL.revokeObjectURL(temp_url)
            return uuid.substr(uuid.lastIndexOf('/') + 1)
        },

        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], { type: mime })
        },
        async getOssToken() {
          let axiosUrl = "";
          if (
            window.location.href.includes("test") ||
            window.location.href.includes("localhost") ||
            window.location.href.includes("medon")
          ) {
            axiosUrl =
              "https://apigateway.medon.com.cn/api/mg/information/ossFile/getToken";
          } else {
            axiosUrl =
              "https://apigateway.medsci.cn/api/mg/information/ossFile/getToken";
          }
          await axios.post(axiosUrl, { type: 1 }).then((response) => {
            if (response.data.status == 200) {
              this.ossValue = {
                region: "oss-cn-shanghai",
                accessKeyId: response.data.data.accessKeyId,
                accessKeySecret: response.data.data.accessKeySecret,
                bucket: response.data.data.publicBucketName,
                stsToken: response.data.data.securityToken,
                timeout: 10 * 1000,
              };
            }
          });
        },
        async oss_upload(base64) {

            // eslint-disable-next-line no-undef
            const uuid = this.getUuid()
            const blob = this.dataURLtoBlob(base64)
             var file = new File([blob], 'qianming.png', {
                type: 'image/png',
                lastModified: Date.now(),
            })
            const cos = new COS({
              SecretId: this.ossValue.accessKeyId,
              SecretKey: this.ossValue.accessKeySecret,
              XCosSecurityToken: this.ossValue.stsToken,
            });
            const data = await cos.uploadFile({
              Bucket: this.ossValue.bucket,
              Region: "ap-shanghai",
              Key: uuid + '_' + 'qianming.png',
              Body: file,
            })
            this.$message.success("上传成功")
            this.cosUrl = 'img.medsci.cn'
            return 'https://' + data.Location.replace(data.Location.split('/')[0], this.cosUrl)




            // let client = new OSS(this.ossValue)
            // const uuid = this.getUuid()
            // const blob = this.dataURLtoBlob(base64)

            // var file = new File([blob], 'qianming.png', {
            //     type: 'image/png',
            //     lastModified: Date.now(),
            // })
            // // const buffer = Buffer.from(file, 'base64')

            // const res = await client.multipartUpload(
            //     uuid + '_' + 'qianming',
            //     file
            // )
            // this.$message.success("上传成功")
            // return 'https://img.medsci.cn/' + res.name
        },
    },
}
</script>

<style scoped>
.signatureBox {
  width: 100%;
  height: calc(100% - 50px);
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  z-index: 100;
  display: flex;
  flex-direction: column;
}
.signatureBox /deep/ .canvasBox {
  box-sizing: border-box;
  flex: 1;
}
.signatureBox /deep/ canvas {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
.signatureBox /deep/ .btnBox {
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
